import { FirebaseAuthTypes } from "capsule"
import React, { createContext, FC, ReactNode, useContext, useMemo, useState } from "react"

interface IMfaContext {
  resolver?: FirebaseAuthTypes.MultiFactorResolver
  setResolver?: React.Dispatch<
    React.SetStateAction<FirebaseAuthTypes.MultiFactorResolver | undefined>
  >
  newPassword?: string
  setNewPassword?: React.Dispatch<React.SetStateAction<string | undefined>>
}

interface IProps {
  children: ReactNode
}

const defaultValues: IMfaContext = {}

export const MfaContext = createContext<IMfaContext>(defaultValues)

const MfaProvider: FC<IProps> = ({ children }) => {
  const [resolver, setResolver] = useState<FirebaseAuthTypes.MultiFactorResolver | undefined>()
  const [newPassword, setNewPassword] = useState<string | undefined>()

  const contextValue: IMfaContext = useMemo(
    () => ({
      resolver,
      setResolver,
      newPassword,
      setNewPassword,
    }),
    [resolver, newPassword],
  )

  return <MfaContext.Provider value={contextValue}>{children}</MfaContext.Provider>
}

export const useMfaResolver = () => {
  const { resolver, setResolver } = useContext(MfaContext)
  return { resolver, setResolver }
}
export const useNewPassword = () => {
  const { newPassword, setNewPassword } = useContext(MfaContext)
  return { newPassword, setNewPassword }
}

export default MfaProvider
